import { render, staticRenderFns } from "./PricingLayout.vue?vue&type=template&id=4a444260"
import script from "./PricingLayout.vue?vue&type=script&lang=js"
export * from "./PricingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports